<template>
  <button
    :class="buttonClass"
    @click="$emit('click')"
    ds-component="DsButton"
    :disabled="disabled"
    v-bind="$attrs"
  >
    <DsIcon v-if="icon" size="small" :name="name" />
    <slot />
  </button>
</template>

<script lang="ts">
import Vue from 'vue';
import { DsIcon } from '@ds/icons';

export default Vue.extend({
  name: 'DsButton',
  components: {
    DsIcon
  },
  props: {
    color: {
      type: String,
      required: false,
      default: 'primary'
    },
    size: {
      type: String,
      required: false,
      default: 'default'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    icon: {
      type: Boolean,
      required: false,
      default: false
    },
    dark: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    buttonClass() {
      return [
        'ds-button',
        `ds-button--${this.color}`,
        `ds-button--${this.size}`,
        this.icon ? `ds-button--icon` : ''
      ];
    }
  },
  mounted() {
    // @ts-ignore
    document.documentElement.setAttribute('data-color-theme', this.dark ? 'dark' : '');
  }
});
</script>

<style lang="scss" scoped>
@import '~@ds/styles/Button.scss';
</style>
